/**
 * The runtime-policy reads as query options. A component passes them to `useQuery` itself, so every component that
 * reads them also renders their failure (`check:query-error-states`) — a failed read never shows as "no policies".
 */
import { queryOptions } from '@tanstack/react-query';
import {
  listModelRuntimePoliciesOptions,
  listModelsOptions,
  listRuntimePolicyOptionsOptions,
  listRuntimePolicySurfaceRulesOptions,
} from '../../generated/api/@tanstack/react-query.gen.js';
import type { RuntimePolicySurface } from '../../generated/api/types.gen.js';

/** Every runtime policy visible to the organization (the system's and its own). */
export const runtimePoliciesQuery = () =>
  queryOptions({
    ...listModelRuntimePoliciesOptions(),
    select: (res) => res.data,
  });

/** The policies a person may pick for a kind of work, the default first. */
export const runtimePolicyOptionsQuery = (surface: RuntimePolicySurface) =>
  queryOptions({
    ...listRuntimePolicyOptionsOptions({ path: { surface } }),
    select: (res) => res.data,
    staleTime: 60_000,
  });

/** The rule of every kind of work the organization runs under (its own, else the system's). */
export const runtimePolicySurfaceRulesQuery = () =>
  queryOptions({
    ...listRuntimePolicySurfaceRulesOptions(),
    select: (res) => res.data,
  });

/** The model bank: every model a runtime policy can list. */
export const modelBankQuery = () =>
  queryOptions({
    ...listModelsOptions(),
    select: (res) => res.data,
  });
